import styled from 'styled-components'
import ArticleCard from './ArticleCard';

const PrimeGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 30vh);

    background: #9AA8B1;

    font-family: "Oswald", sans-serif;
    font-weight: 600;
    font-size: 18vh;

    border: 2px solid black;
    line-height: 30vh;


    .P {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    .R {
        grid-row: 1;
        grid-column: 2;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }

    .I {
        grid-row: 1;
        grid-column: 3;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }

    .M {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    .E {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }

    .A1 {
        grid-row: 2;
        grid-column: 1 / 3;
        border: inherit;
    }
    .Blank {
        grid-row: 1;
        grid-column: 4;
        border: inherit;

    }

`;


const Prime = (props) => {
    let a1 = props.prime[0];
    return (
        <>
            <PrimeGrid>
                <div class="P">P</div>
                <div class="R">R</div>
                <div class="I">I</div>
                <div class="M">M</div>
                <div class="E">E</div>

                <div class="Blank"></div>

                <div class="A1">
                    <ArticleCard
                        position='right'
                        article_title={a1.article_title}
                        article_byline={a1.article_byline}
                        article_image={a1.article_image} article_url={a1.article_url}></ArticleCard>
                </div>
            </PrimeGrid>

        </>
    )
}

export default Prime;